import { companyApi } from "./company.api";

export const { useGetCompaniesQuery, useGetCompanyByHostQuery, useGetCompanyQuery, useCreateCompanyMutation, useUpdateCompanyMutation, useDeleteCompanyMutation } = companyApi;
